(() => {
  const init = () => document.querySelectorAll('[data-r1-catalog-directory]').forEach(directory => {
    if (directory.dataset.ready) return;
    directory.dataset.ready = 'true';
    const input = directory.querySelector('[data-r1-directory-search]');
    const groups = [...directory.querySelectorAll('[data-r1-directory-group]')];
    const status = directory.querySelector('[data-r1-directory-status]');
    const empty = directory.querySelector('[data-r1-directory-empty]');
    const update = () => {
      const words = input.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
      let count = 0;
      groups.forEach(group => {
        let matches = 0;
        group.querySelectorAll('[data-r1-directory-item]').forEach(item => {
          const show = words.every(word => item.dataset.search.includes(word));
          item.hidden = !show;
          if (show) matches++;
        });
        group.hidden = matches === 0;
        if (words.length) group.open = matches > 0;
        else group.open = false;
        count += matches;
      });
      status.textContent = count + ' ' + (count === 1 ? directory.dataset.matchSingular : directory.dataset.matchPlural);
      empty.hidden = count !== 0;
    };
    input.addEventListener('input', update);
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
